import { __decorate, __extends } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import { ROUTE_NAME } from '@/lib/constant';
import PopupComponent from '@/components/messageBox/popup';
import router from '@/router'; // 18届 切换套餐弹窗

var ChangePackagePopup =
/** @class */
function (_super) {
  __extends(ChangePackagePopup, _super);

  function ChangePackagePopup() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  ChangePackagePopup.prototype.onClickCloseChangePackagePopup = function () {
    this.value = false;
  };

  ChangePackagePopup.prototype.onClickDetail = function () {
    this.onClickCloseChangePackagePopup();
    router.push({
      name: ROUTE_NAME.ACTIVITY_EQUIPMENT,
      params: {
        activityId: '24'
      }
    });
  };

  ChangePackagePopup = __decorate([Component({
    name: 'ChangePackagePopup',
    template: "<MyPopup v-model=\"value\" :modal=\"true\" class=\"change-package-popup\" position=\"center\">\n        <div class=\"change-package-popup__content\" @click=\"onClickDetail\">\n            <div><i class=\"icon fr\" @click.stop=\"onClickCloseChangePackagePopup\">&#xe64b;</i></div>\n        </div>\n    </MyPopup>"
  })], ChangePackagePopup);
  return ChangePackagePopup;
}(Mixins(PopupComponent));

export { ChangePackagePopup };